// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IwOq","option":"styles_option__1ThvU","selected":"styles_selected__Bg5no"};